// console.log( 'Silence is golden.' );

// some other file.js
var selector = '#field_3_6';
var elList = document.querySelectorAll( selector );
var i;

for ( i = 0; i < elList.length; i++ ) {
	var a11yFUP = new A11yFileUpload();
	a11yFUP.init( elList[i] );
};

/**
 * Get the stock data from the Yahoo API
 */
// fetch( 'https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/v2/get-summary?symbol=OZSC&region=US', {
// 	'credentials': 'omit',
// 	'headers': {
// 		'x-rapidapi-key': '8e7b607b7cmsh70f16e2a8321e85p10b35fjsn577f141a34f6',
// 		'x-rapidapi-host': 'apidojo-yahoo-finance-v1.p.rapidapi.com'
// 	},
// 	'method': 'GET',
// } )
// .then( response => response.json() )
// .then( data => {
// 	const isInvestorsPage = document.querySelector( '[data-stock-price]' );
// 	if ( data.price.regularMarketPrice.raw && isInvestorsPage ) {
// 		const price = data.price.regularMarketPrice.raw;
// 		isInvestorsPage.classList.remove( 'dn' );
// 		isInvestorsPage.classList.add( 'flex' );
// 		const currentPrice = document.querySelector( '[data-current-price]' );
// 		const roundedPrice = Math.ceil( price * 1000 ) / 1000;
// 		currentPrice.textContent = `$${roundedPrice}`;
// 	}
// } ).catch( err => {
// 	console.warn( 'Something went wrong.', err );
// } );
